import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { PolicyService } from 'src/app/modules/policy/policy.service';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { IPolicyAsset } from 'src/app/modules/shared/models/policy.model';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { EProductType, IIbanObject, MULTISOLUTION_PRODUCTS } from '../../athora.constants';
import { ASSETS_TABLE_TABLE_KEYS } from '../../../shared/components/assets-table/assets-table.constants';
import { PARTIAL_REDEEM_ASSETS_TABLE_TABLE_KEYS, partial_redeem_form_keys } from './partial-redeem.constants';

@Component({
  selector: 'app-partial-redeem',
  templateUrl: './partial-redeem.component.html',
  styleUrl: './partial-redeem.component.scss',
})
export class PartialRedeemComponent implements OnChanges, OnDestroy {

  @Input() form: FormGroup;
  @Input() ibanList: IIbanObject[];
  @Input() assets: IPolicyAsset[] = [];
  @Input() funds: IPolicyAsset[] = [];
  @Input() isReadOnly: boolean;
  formKeys: IFormKey[] = CommonUtils.assign(partial_redeem_form_keys);
  destroy$ = new Subject();

  @Output() emitFunds = new EventEmitter<any>();

  constructor(
    private _policyService: PolicyService
  ) { }

  get showFunds(): boolean {
    return this.funds && this.funds.length > 0;
  }

  get showAssets(): boolean {
    return this.assets && this.assets.length > 0;
  }

  get isMultistrategyProduct(): boolean {
    return MULTISOLUTION_PRODUCTS.includes(EProductType[this._policyService.productCode]);
  }

  get tableKeys(): ITableKey[] {
    return this.isMultistrategyProduct ? ASSETS_TABLE_TABLE_KEYS : PARTIAL_REDEEM_ASSETS_TABLE_TABLE_KEYS;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ibanList'] && changes['ibanList'].currentValue) {
      this.populateIbanOptions();
    }
  }

  populateIbanOptions(): void {
    this.formKeys = CommonUtils.populateIbanOptions(this.formKeys, this.ibanList);
  }

  readFunds(funds: IPolicyAsset[]) {
    this.emitFunds.emit(funds);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
